import { combineReducers } from 'redux';
import { machineAttachmentsReducer } from 'home/HomePage/reducers/machineAttachments.reducer';
import { completionStatus, machineDetails } from './reducers/machineDetails.reducer';
import { machineDetailsTags } from './reducers/machineDetailsTags.reducer';
import { picturesReducer } from './Pictures/pictures.reducer';
import { analystReducer } from './Analyst/reducer';
import MachineInfoReducer from './MachineInfo/reducers/machineInfo.reducers';
import MachineMLReducer from './Health/reducers/machineML.reducers';
import MachineDiagnosticTestRunReducer from './Health/reducers/DiagnosticTestRun.reducers';
import MachineBhsReducer from './Health/reducers/machineBhs.reducers';
import MachineChartsReducer from './MachineCharts/reducers/machineCharts.reducers';
import MachineOverviewReducer from './MachineOverview/reducers/machineOverview.reducers';
import graphicsReducer from './MachineOverview/reducers/graphics.reducers';
import analystSummaryReducer from './Health/reducers/analystSummary.reducers';
// Deliberately a direct import, not the ./Digital3DView barrel. This module is
// part of the store wiring, so it sits upstream of everything; pulling in the
// barrel drags the twin's action creators along, those reach common/utils, and
// that comes back around to this file — a cycle that leaves the barrel's
// exports undefined at import time.
// eslint-disable-next-line no-restricted-imports
import digitalTwinReducer from './Digital3DView/reducers/digitalTwin.reducer';

export const reducer = combineReducers({
  details: machineDetails,
  tags: machineDetailsTags,
  pictures: picturesReducer,
  info: MachineInfoReducer,
  ML: MachineMLReducer,
  DiagnosticTestRun: MachineDiagnosticTestRunReducer,
  BHS: MachineBhsReducer,
  AS: analystSummaryReducer,
  charts: MachineChartsReducer,
  overview: MachineOverviewReducer,
  analyst: analystReducer,
  graphics: graphicsReducer,
  digitalTwin: digitalTwinReducer,
  completion_status: completionStatus,
  attachments: machineAttachmentsReducer,
});

// machineDetails reducer to reset back to initial state when requested for a new machine details.
export const machineDetailsReducer = (state, action) => reducer(state, action);
